/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Enrich_Already_YoursInputs */

const en_directory_submit_enrich_already_yours = /** @type {(inputs: Directory_Submit_Enrich_Already_YoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You already submitted this website — continue in My Tools.`)
};

const zh_directory_submit_enrich_already_yours = /** @type {(inputs: Directory_Submit_Enrich_Already_YoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`该网站已由你提交过——请到“我的工具”继续操作。`)
};

/**
* | output |
* | --- |
* | "You already submitted this website — continue in My Tools." |
*
* @param {Directory_Submit_Enrich_Already_YoursInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_enrich_already_yours = /** @type {((inputs?: Directory_Submit_Enrich_Already_YoursInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Enrich_Already_YoursInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_enrich_already_yours(inputs)
	return zh_directory_submit_enrich_already_yours(inputs)
});
export { directory_submit_enrich_already_yours as "directory.submit.enrich.already_yours" }